import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faRedoAlt } from '@fortawesome/pro-solid-svg-icons';

import Tooltip from 'components/tooltip';

export default function OverrideButton({ disabled, onRemove, onReset }) {
  const ref = React.createRef();

  if (disabled) return (
    <Tooltip childrenRef={ref} content="Override this option to specify your own defaults">
      <a
        className="text-muted clickable"
        name="override-default"
        ref={ref}
        onClick={onReset}
      >
        <FontAwesomeIcon className="mr-2" icon={faEdit}/> Click to Override
      </a>
    </Tooltip>
  );

  return (
    <Tooltip childrenRef={ref} content="Revert to designer specified defaults">
      <a
        className="clickable"
        name="use-default"
        ref={ref}
        style={{ width: '119px' }}
        onClick={onRemove}
      >
        <FontAwesomeIcon className="mr-2" icon={faRedoAlt}/> Reset to Buildout Default
      </a>
    </Tooltip>
  );
}

OverrideButton.propTypes = {
  disabled: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired
};
